import {
  aLogMapping,
  aLogMappingOptions,
  aLogMappingRecordTypeOption,
  mockSchemaFieldQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockSchemaFieldQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          logMappingOptions: aLogMappingOptions(
            {
              recordTypeOptions: [
                aLogMappingRecordTypeOption({
                  objectType: aLogMapping().recordType,
                }),
              ],
            },
            new Set<string>([
              'fieldValueTypeOptions',
              'logFormatOptions',
              'parsingPatternOptions',
            ])
          ),
        },
      });
    }
  ),
];
